import { http } from 'http';

export default {
  updateDriverInfo: data => http.post('driversweb/drivers/updateDriverInfo', data),
  sendMailContactUs: (driverIdEncrypted, carPlateEncrypted, data) =>
    http.post(
      `driversweb/vehicles/drivers/contactus?driverId=${driverIdEncrypted}&plate=${carPlateEncrypted}`,
      data
    ),
  updateKmsOperation: (operationIdEncrypted, kms) =>
    http.post(`driversweb/vehicles/operations/kms?operationId=${operationIdEncrypted}`, { kms }),
  saveInfoUser: data => http.post('/LegacyApi/app/SaveInfoUser', data),
  validateDocument: data => http.post('/edoc/validate', data),
  getDocuments: fileNames => http.post('/edoc/documents', { fileNames }),
  sendDriverAvatar: (driverIdEncrypted, data) =>
    http.post(`/driversweb/drivers/avatar?driverId=${driverIdEncrypted}`, data),
  getAutologin: encryptData => http.post('driversweb/drivers/autologin', encryptData),
  appliedConsents: (driverIdEncrypted, consents) =>
    http.post(`/driversweb/appliedDriverConsents?driverId=${driverIdEncrypted}`, consents),
  createCRMWebConductores: data => http.post('driversweb/CreateCRMWebConductores', data),
  authorizationVehicleSerCard: data => http.post('/driversweb/authorizationvehicle/SerCard', data),
  authorizationDepositExit: data => http.post('/driversweb/authorizationvehicle/DepositExit', data),
  authorizationAccessoriesAssembly: data =>
    http.post('/driversweb/authorizationvehicle/AccessoriesAssembly', data),
  foreignNational: data => http.post('/driversweb/authorizationvehicle/ForeignNational', data),
  replacementVehicleCoverage: carPlate =>
    http.post('/driversweb/replacementvehicle/coverage', carPlate),
  replacementVehicleProcessRequest: data =>
    http.post('/driversweb/replacementvehicle/processrequest', data)
};
